<script>
import {required} from "vuelidate/lib/validators";
import appConfig from "@/app.config";
import {notifyModel} from "@/models/notifyModel";
import {pagingModel} from "@/models/pagingModel";
import Multiselect from "vue-multiselect";
import {userModel} from "@/models/userModel";
import Treeselect from '@riophae/vue-treeselect'
import Switches from "vue-switches";
import LetterCube from "../../components/LetterCube.vue";
export default {
  page: {
    title: "Tài khoản",
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {Multiselect, Treeselect, Switches, LetterCube},
  data() {
    return {
      title: "Tài khoản",
      fields: [
        {key: 'STT', label: 'STT', class: 'td-stt', sortable: false},
        {
          key: "userName",
          label: "Tài khoản",
          class: 'td-username',
          sortable: true,
          thClass: 'hidden-sortable',
          thStyle: "text-align:center; min-width: 150px;"
        },
        {
          key: "fullName",
          label: "Họ và tên",
          class: 'td-ten',
          thClass: 'hidden-sortable',
          thStyle: "min-width: 200px;"
        },
        {
          key: "chucVu",
          label: " Chức vụ",
          class: 'td-donVi',
          thClass: 'hidden-sortable',
          thStyle: "min-width: 200px;"
        },
        {
          key: "donVi",
          label: "Đơn vị",
          class: 'td-donVi',
          thClass: 'hidden-sortable',
          thStyle: "min-width: 200px;"
        },
        {
          key: "roles",
          label: "Quyền",
          class: 'td-email',
          thClass: 'hidden-sortable',
          thStyle: "min-width: 150px;"
        },
        {
          key: 'process',
          label: 'Xử lý',
          class: 'td-xuly',
          thClass: 'hidden-sortable',
          thStyle: "min-width: 100px;"
        }
      ],
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 25, 50, 100],
      showModal: false,
      showDeleteModal: false,
      submitted: false,
      sortBy: "age",
      filter: null,
      sortDesc: false,
      filterOn: [],
      numberOfElement: 1,
      totalRows: 1,
      model: userModel.baseJson(),
      listCoQuan: [],
      listRole: [],
      listChucVu: [],
      pagination: pagingModel.baseJson(),
      itemFilter: {
        code: null,
        name: null,
        chucVu: null,
        donVi: null,
        role: null,
        isBlockAccount: false
      },
      optionsDonVi: [],
      showUnclockAccount: false,
      isBusy: false,
      showResetPassword: false
    };
  },
  validations: {
    model: {
      userName: {required},
      firstName: {required},
      lastName: {required},
      donVi: {required},
      roles: {required},
      chucVu: {required},
    },
  },
  methods: {
    handleShowUnclockAccount(item) {
      this.model = item;
      this.showUnclockAccount = true;
    },
    async handleUnclockAccount(e) {
      e.preventDefault();
      let loader = this.$loading.show({
        container: this.$refs.formContainer,
      });
      await this.$store.dispatch("userStore/unblockAccount", this.model.id).then((res) => {
        if (res.resultCode === 'SUCCESS') {
          this.fnGetList();
          this.model = userModel.baseJson()
          this.showUnclockAccount = false;
        }
        this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res));
        loader.hide()
      });
    },
    clearSearch() {
      this.itemFilter.code = null;
      this.itemFilter.name = null;
    },
    normalizer(node) {
      if (node.children == null || node.children == 'null') {
        delete node.children;
      }
    },
    async fnGetList() {
      this.$refs.tblList?.refresh()
    },
    async getListRole() {
      await this.$store.dispatch("roleStore/getAll").then((res) => {
        this.listRole = res.data || [];
      })
    },
    async getListChucVu() {
      await this.$store.dispatch("chucVuStore/getAll").then((res) => {
        this.listChucVu = res.data || [];
      })
    },
    async getListCoQuan() {
      await this.$store.dispatch("donViStore/getTree").then((res) => {
        this.listCoQuan = res.data || [];
      })
    },
    async handleDelete() {
      if (this.model.id != 0 && this.model.id != null && this.model.id) {
        await this.$store.dispatch("userStore/delete", this.model.id).then((res) => {
          if (res.resultCode === 'SUCCESS') {
            this.fnGetList();
            this.showDeleteModal = false;
          }
          this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res));
        });
      }
    },
    handleShowDeleteModal(id) {
      this.model.id = id;
      this.showDeleteModal = true;
    },
    async handleSubmit(e) {
      e.preventDefault();
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        let loader = this.$loading.show({
          container: this.$refs.formContainer,
        });
        if (
            this.model.id != 0 &&
            this.model.id != null &&
            this.model.id
        ) {
          // Update model
          await this.$store.dispatch("userStore/update", this.model).then((res) => {
            if (res.resultCode === 'SUCCESS') {
              this.showModal = false;
              this.model = userModel.baseJson();
              this.$refs.tblList.refresh();
            }
            this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res))
          });
        } else {
          // Create model
          await this.$store.dispatch("userStore/create", this.model).then((res) => {
            if (res.resultCode === 'SUCCESS') {
              this.fnGetList();
              this.showModal = false;
              this.model = userModel.baseJson();
            }
            this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res))
          });
        }
        loader.hide();
      }
      this.submitted = false;
    },
    async handleUpdate(id) {
      await this.$store.dispatch("userStore/getById", id).then((res) => {
        if (res.resultCode === 'SUCCESS') {
          this.model = userModel.toJson(res.data);
          this.showModal = true;
        } else {
          this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res));
        }
      });
    },
    async handleShowModalResetPassword(item, show = false){
      if(item)
        this.model = item
      this.showResetPassword = show;
    },
    async handleResetPassword(e) {
      e.preventDefault();
      let loader = this.$loading.show({
        container: this.$refs.formContainer,
      });
      await this.$store.dispatch("userStore/resetPassword", this.model).then((res) => {
        if (res.resultCode === 'SUCCESS') {
          this.model = userModel.baseJson();
          this.showResetPassword = false;
        }
        this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res));
        loader.hide()
      });
    },
    addCoQuanToModel: function (node, instanceId) {
      if (node.id) {
        this.model.donVi = {id: node.id, ten: node.label};
      }
    },
    async getDonVi() {
      try {
        await this.$store.dispatch("donViStore/get").then(resp => {
          if (resp.resultCode == "SUCCESS") {
            let items = resp.data
            this.loading = false
            this.optionsDonVi = items;
          }
          return [];
        });
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.isSearch = true;
      this.$refs.tblList.refresh()
    },
    myProvider(ctx) {
      const params = {
        start: ctx.currentPage,
        limit: ctx.perPage,
        content: this.filter,
        sortBy: ctx.sortBy,
        sortDesc: ctx.sortDesc,
        chucVu: this.itemFilter.chucVu,
        donVi: this.itemFilter.donVi,
        role: this.itemFilter.role,
        isBlockAccount: this.itemFilter.isBlockAccount
      }
      this.loading = true
      try {
        let promise = this.$store.dispatch("userStore/getPagingParams", params)
        return promise.then(resp => {
          let items = resp.data.data
          this.totalRows = resp.data.totalRows
          this.numberOfElement = resp.data.data.length
          this.loading = false
          return items || []
        })
      } finally {
        this.loading = false
      }
    },
    async handleExport() {
      await this.$store
          .dispatch("exportStore/dsUser")
          .then((res) => {
            var blob = new Blob(
                [this.base64ToArrayBuffer(res.fileContents)],
                {type: "application/xlsx"}
            );
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            var fileName = res.fileDownloadName;
            link.download = fileName;
            link.click();
          })
          .catch((e) => {
            console.log(e);
          });
    },
    base64ToArrayBuffer(base64) {
      var binaryString = window.atob(base64);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    },
  },
  created() {
    this.getListChucVu();
    this.getListRole();
    this.getListCoQuan();
    this.getDonVi();
  },
  mounted() {

  },
  watch: {
    itemFilter: {
      deep: true,
      handler(val) {
        this.fnGetList()
      }
    },
    showModal(status) {
      if (status == false) this.model = userModel.baseJson();
    },
    showDeleteModal(val) {
      if (val == false) {
        this.model.id = null;
      }
    }
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card mb-2">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4 col-12 d-flex align-items-center">
                <h4 class="font-size-18 fw-bold text-dark">Tài khoản</h4>
              </div>
              <div class="col-md-8 col-12 text-end">
                <b-button v-b-toggle.collapseSearch variant="light"
                          class="btn w-md btn-primary-outline me-2" size="sm">
                  <i class="fas fa-caret-down align-middle me-2"></i>
                  Tìm kiếm
                </b-button>
                <b-button
                    type="button"
                    variant="primary"
                    class="w-md"
                    size="sm"
                    @click="showModal = true"
                >
                  <i class="mdi mdi-plus me-1"></i> Tạo tài khoản
                </b-button>
              </div>
            </div>
            <b-collapse id="collapseSearch" class="mt-1">
              <div class="row">
                <div class="col-12">
                  <div class="d-flex justify-content-between align-items-end flex-wrap mb-2">
                    <!-- Nội dung -->
                    <div class="flex-grow-1 me-2">
                      <label> Nội dung</label>
                      <input
                          size="sm"
                          type="text"
                          name="untyped-input"
                          class="form-control"
                          v-model="filter"
                          placeholder=" Tên, tên tài khoản, ..."
                      />
                    </div>
                    <!-- Đơn vị-->
                    <div class="flex-grow-1 me-2">
                      <label>Đơn vị</label>
                      <multiselect
                          v-model="itemFilter.donVi"
                          :options="optionsDonVi"
                          track-by="id"
                          label="ten"
                          placeholder="Chọn đơn vị"
                          deselect-label="Nhấn để xoá"
                          selectLabel="Nhấn enter để chọn"
                          selectedLabel="Đã chọn"
                      ></multiselect>
                    </div>
                    <div class="flex-grow-1 me-2">
                      <label>Chức vụ</label>
                      <multiselect
                          v-model="itemFilter.chucVu"
                          :options="listChucVu"
                          track-by="id"
                          label="ten"
                          placeholder="Chọn chức vụ"
                          deselect-label="Nhấn để xoá"
                          selectLabel="Nhấn enter để chọn"
                          selectedLabel="Đã chọn"
                      ></multiselect>
                    </div>
                    <div class="flex-grow-1 me-2">
                      <label>Quyền</label>
                      <multiselect
                          v-model="itemFilter.role"
                          :options="listRole"
                          track-by="id"
                          label="ten"
                          placeholder="Chọn quyền"
                          deselect-label="Nhấn để xoá"
                          selectLabel="Nhấn enter để chọn"
                          selectedLabel="Đã chọn"
                      ></multiselect>
                    </div>
                    <div class="flex-grow-2 me-2" >

                      <div class="d-flex justify-content-center align-content-center">
                        <switches v-model="itemFilter.isBlockAccount"  color="primary" class="ml-1 me-2"></switches>
                        <label> Tài khoản bị khóa</label>
                      </div>

                    </div>
                    <!--  Xử lý -->
                    <div class="flex-grow-0 ms-2">
                      <div class="d-flex justify-content-between align-items-center flex-wrap">
                        <div class="flex-grow-1 mt-xl-0 mt-2">
                          <b-button @click="handleExport" variant="light"
                                    class="btn w-md btn-primary me-2" size="md">
                            <i class="far fa-file-excel align-middle me-2"></i>
                            Xuất danh sách
                          </b-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-collapse>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <div class="row mb-3">
                  <div class="col-sm-12 col-md-6">
                    <div id="tickets-table_length" class="dataTables_length">
                      <label class="d-inline-flex align-items-center">
                        Hiện
                        <b-form-select
                            class="form-select form-select-sm"
                            v-model="perPage"
                            size="sm"
                            :options="pageOptions"
                        ></b-form-select
                        >&nbsp;dòng
                      </label>
                    </div>
                  </div>
                </div>
                <div class="table-responsive mb-0">
                  <b-table
                      class="datatables"
                      :items="myProvider"
                      :fields="fields"
                      striped
                      bordered
                      responsive="md"
                      :per-page="perPage"
                      :current-page="currentPage"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      :filter="filter"
                      :filter-included-fields="filterOn"
                      ref="tblList"
                      primary-key="id"
                      :busy.sync="isBusy"
                  >
                    <template v-slot:cell(STT)="data">
                      {{ data.index + ((currentPage - 1) * perPage) + 1 }}
                    </template>
                    <template v-slot:cell(roles)="row">
                      <div v-for="(item,index) in row.value" :key="index">
                              <span>
                                {{ item.ten }}
                              </span>
                      </div>
                    </template>
                    <template v-slot:cell(chucVu)="data">
                      <div v-if="data.item.chucVu">
                        {{ data.item.chucVu.ten }}
                      </div>

                    </template>
                    <template v-slot:cell(donVi)="data">
                      <div v-if="data.item.donVi">
                        {{ data.item.donVi.ten }}
                      </div>

                    </template>
                    <template v-slot:cell(process)="data">
                      <button
                          type="button"
                          size="sm"
                          class="btn btn-edit btn-sm"
                          v-on:click="handleUpdate(data.item.id)">
                        <i class="fas fa-pencil-alt"></i>
                      </button>
                      <button
                          type="button"
                          size="sm"
                          class="btn btn-delete btn-sm"
                          v-on:click="handleShowDeleteModal(data.item.id)">
                        <i class="fas fa-trash-alt"></i>
                      </button>

                      <button
                          v-if="!data.item.isActived"
                          type="button"
                          size="sm"
                          class="btn btn-primary btn-sm"
                          v-on:click="handleShowUnclockAccount(data.item)">
                        <i class="fas fa-unlock"></i>
                      </button>
                      <button
                          type="button"
                          size="sm"
                          class="btn btn-success btn-sm"
                          v-on:click="handleShowModalResetPassword(data.item, true)">
                        <i class="fas fa-history"></i>
                      </button>
                    </template>
                  </b-table>
                  <template v-if="isBusy">
                    <div align="center">
                      <LetterCube></LetterCube>
                    </div>
                  </template>
                  <template v-if="totalRows <= 0 && !isBusy">
                    <div align="center">Không có dữ liệu</div>
                  </template>
                </div>

                <div class="row">
                  <b-col>
                    <div>Hiển thị {{ numberOfElement }} trên tổng số {{ totalRows }} dòng</div>
                  </b-col>
                  <div class="col">
                    <div
                        class="dataTables_paginate paging_simple_numbers float-end">
                      <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="totalRows"
                            :per-page="perPage"
                        ></b-pagination>
                      </ul>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
        v-model="showDeleteModal"
        centered
        title="Xóa dữ liệu"
        title-class="font-18"
        no-close-on-backdrop
    >
      <p>
        Dữ liệu xóa sẽ không được phục hồi!
      </p>
      <template #modal-footer>
        <button v-b-modal.modal-close_visit
                class="btn btn-outline-info m-1"
                v-on:click="showDeleteModal = false">
          Đóng
        </button>
        <button v-b-modal.modal-close_visit
                class="btn btn-danger btn m-1"
                v-on:click="handleDelete">
          Xóa
        </button>
      </template>
    </b-modal>
    <b-modal
        v-model="showUnclockAccount"
        centered
        title="Mở khóa tài khoản"
        title-class="font-18"
        no-close-on-backdrop
        hide-footer
        hide-header-close
    >
      <form @submit.prevent="handleUnclockAccount"
            ref="formContainer"
      >
        <div class="row">
          <div class="col-12">
            <p>
              Mở khóa tài khoản <strong style="color: red"> {{ model.userName }} - {{ model.fullName }}</strong>
            </p>
          </div>
        </div>
        <div class="text-end pt-2">
          <b-button variant="light" class="w-md" @click="showUnclockAccount = false">
            Đóng
          </b-button>
          <b-button type="submit" variant="primary" class="ms-1 w-md">   Mở khóa
          </b-button>
        </div>
      </form>
    </b-modal>
    <b-modal
        v-model="showModal"
        title="Thông tin tài khoản"
        title-class="text-black font-18"
        body-class="p-3"
        hide-footer
        centered
        no-close-on-backdrop
        size="lg"
    >
      <form @submit.prevent="handleSubmit"
            ref="formContainer"
      >
        <div class="row">
          <div class="col-6">
            <div class="mb-3">
              <label class="text-left">Tên tài khoản</label>
              <span style="color: red">&nbsp;*</span>
              <input type="hidden" v-model="model.id"/>
              <input
                  id="userName"
                  v-model.trim="model.userName"
                  type="text"
                  class="form-control"
                  placeholder="Nhập tài khoản"
                  :class="{
                                'is-invalid':
                                  submitted && $v.model.userName.$error,
                              }"
              />
              <div
                  v-if="submitted && !$v.model.userName.required"
                  class="invalid-feedback"
              >
                Tên tài khoản không được trống.
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label class="text-left">Mật khẩu</label>
              <input type="hidden" v-model="model.id"/>
              <input
                  id="password"
                  v-model="model.password"
                  type="password"
                  class="form-control"
                  placeholder="Nhập mật khẩu"
              />
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label class="text-left">Họ</label>
              <span style="color: red">&nbsp;*</span>
              <input type="hidden" v-model="model.id"/>
              <input
                  id="lastName"
                  v-model="model.lastName"
                  type="text"
                  class="form-control"
                  placeholder="Nhập họ"
                  :class="{
                                'is-invalid':
                                  submitted && $v.model.lastName.$error,
                              }"
              />
              <div
                  v-if="submitted && !$v.model.lastName.required"
                  class="invalid-feedback"
              >
                Họ không được trống.
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label class="text-left">Tên</label>
              <span style="color: red">&nbsp;*</span>
              <input
                  id="firstName"
                  v-model="model.firstName"
                  type="text"
                  class="form-control"
                  placeholder="Nhập tên"
                  :class="{
                                'is-invalid':
                                  submitted && $v.model.firstName.$error,
                              }"
              />
              <div
                  v-if="submitted && !$v.model.firstName.required"
                  class="invalid-feedback"
              >
                Tên không được trống.
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label class="text-left">Số điện thoại</label>
              <input type="hidden" v-model="model.id"/>
              <input
                  id="phoneNumber"
                  v-model="model.phoneNumber"
                  type="text"
                  class="form-control"
                  placeholder="Nhập số điện thoại"
              />
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label class="text-left">Email</label>
              <input type="hidden" v-model="model.id"/>
              <input
                  id="email"
                  v-model="model.email"
                  type="email"
                  pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                  class="form-control"
                  placeholder="Nhập email"
              />
            </div>
          </div>
          <div v-if="model.donVi" class="col-6">
            <div class="mb-3">
              <label class="text-left">Cơ quan</label>
              <span style="color: red">&nbsp;*</span>
              <treeselect
                  :options="listCoQuan"
                  :value="model.donVi.id"
                  :flat="true"
                  :searchable="true"
                  :show-count="true"
                  :default-expand-level="5"
                  placeholder="Chọn cơ quan"
                  :normalizer="normalizer"
                  v-on:select="addCoQuanToModel"
                  :class="{
                                'is-invalid':
                                  submitted && $v.model.donVi.$error,
                              }"

              >
                <label slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }"
                       :class="labelClassName">
                  {{ node.label }}
                  <span v-if="shouldShowCount" :class="countClassName">({{ count }})</span>
                </label>
              </treeselect>
              <div
                  v-if="submitted && !$v.model.donVi.required"
                  class="invalid-feedback"
              >
                Cơ quan không được trống.
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label class="text-left">Vai trò</label>
              <span style="color: red">&nbsp;*</span>
              <multiselect v-model="model.roles"
                           :options="listRole"
                           label="ten"
                           :multiple="true"
                           selectLabel="Nhấn vào để chọn"
                           deselectLabel="Nhấn vào để xóa"
                           track-by="id"
                           :class="{
                                'is-invalid':
                                  submitted && $v.model.roles.$error,
                              }"
                           placeholder="Chọn vai trò"
              ></multiselect>
              <div
                  v-if="submitted && !$v.model.roles.required"
                  class="invalid-feedback"
              >
                Vai trò không được trống.
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label class="text-left"> Chức vụ</label>
              <span style="color: red">&nbsp;*</span>
              <multiselect v-model="model.chucVu"
                           :options="listChucVu"
                           label="ten"
                           selectLabel="Nhấn vào để chọn"
                           deselectLabel="Nhấn vào để xóa"
                           track-by="id"
                           :class="{
                                'is-invalid':
                                  submitted && $v.model.chucVu.$error,
                              }"
                           placeholder="Chọn vai trò"
              ></multiselect>
              <div
                  v-if="submitted && !$v.model.chucVu.required"
                  class="invalid-feedback"
              >
                Vai trò không được trống.
              </div>
            </div>
          </div>
        </div>
        <div class="text-end pt-2">
          <b-button variant="light" class="w-md" @click="showModal = false">
            Đóng
          </b-button>
          <b-button type="submit" variant="primary" class="ms-1 w-md">Lưu
          </b-button>
        </div>
      </form>
    </b-modal>

<!--    Reset password-->
    <b-modal
        v-model="showResetPassword"
        centered
        title="Đặt lại mật khẩu mặc định"
        title-class="font-18"
        no-close-on-backdrop
        hide-footer
        hide-header-close
    >
      <form @submit.prevent="handleResetPassword"
            ref="formContainer"
      >
        <div class="row">
          <div class="col-12">
            <p >
              Đặt lại mật khẩu mặc định tài khoản <strong style="color: red"> {{ model.userName }} - {{ model.fullName }}</strong>
            </p>
          </div>
        </div>
        <div class="text-end pt-2">
          <b-button variant="light" class="w-md" @click="handleShowModalResetPassword(null, false)">
            Đóng
          </b-button>
          <b-button type="submit" variant="primary" class="ms-1 w-md"> Đặt lại
          </b-button>
        </div>
      </form>

    </b-modal>
  </div>
</template>
<style>
.td-stt {
  text-align: center;
  width: 55px;
}

.td-username {
  text-align: center;
  width: 120px;
}

.td-ten {
  text-align: center;
  width: 140px;
}

.td-email {
  text-align: center;
  width: 120px;
}

.td-donVi {
  text-align: center;
  width: 180px;
}

.td-xuly {
  text-align: center;
  width: 80px;
}

.td-sodienthoai {
  text-align: center;
  width: 100px;
}
.hidden-sortable:after,
.hidden-sortable:before {
  display: none !important;
}
</style>
